import { useEffect, useState } from "react";
import { payApi, type JobRole } from "../../../api/pay";

const sel = "h-11 w-full rounded-sm border border-white/15 bg-surface px-3 text-sm text-white";

export function RoleSelect({ value, legacy, onChange }: { value: string; legacy: string | null; onChange: (v: string) => void }) {
  const [roles, setRoles] = useState<JobRole[]>([]);
  useEffect(() => {
    payApi.roles().then(setRoles).catch(() => setRoles([]));
  }, []);
  return (
    <>
      <select id="shift-role" className={sel} value={value} onChange={(e) => onChange(e.target.value)} data-testid="shift-role-select">
        <option value="">{legacy ? `Keep "${legacy}" (unmapped)` : "Select a role…"}</option>
        {roles.filter((r) => r.status === "ACTIVE" || r.id === value).map((r) => (
          <option key={r.id} value={r.id}>{r.name}</option>
        ))}
      </select>
      {legacy && <p className="mt-1 text-[11px] text-amber-300" data-testid="shift-role-unmapped-note">Original role text “{legacy}” is not a job role. Pick one so pay rates apply.</p>}
    </>
  );
}
